
export const BKASH_NUMBER = "01775559622";
export const ROCKET_NUMBER = "01775559622";
export const NAGAD_NUMBER = "01775559622";

export const TOPUPS_COLLECTION = 'topups';
export const DIAMONDS_COLLECTION = 'diamonds';
export const USERS_COLLECTION = 'users';
export const ADMINS_COLLECTION = 'admins';
export const SETTINGS_COLLECTION = 'settings';

export const CHATS_COLLECTION = 'chats';
export const CHATS_MESSAGES_COLLECTION = 'messages';

export const STATUS_PENDING = 'pending';
export const STATUS_PROCESSING = 'processing';
export const STATUS_DISABLED = 'disabled';
export const STATUS_CANCELED = 'canceled';
export const STATUS_DONE = 'done';
export const STATUS_ACTIVE = 'active';

export const PAYMENT_METHOD_BKASH = 'Bkash';

export const GAME = 'Free Fire';

export const ICON_GOOGLE = 'assets/google.svg';
export const ICON_TAKA = 'assets/taka.svg';
export const CHARECTER_1 = 'assets/charecter1.svg';

export const _TAKA_ = '৳';